import { useT } from '../../../i18n';
import { ngayVN, soVN } from '../../../lib/dinh-dang';
import type { LoiNgay, LoiSo } from '../nghiep-vu/cap-them-token';
import { TOKEN_TOI_DA } from '../nghiep-vu/han-muc-token';

/** Dịch mã lỗi của `nghiep-vu/cap-them-token.ts` thành câu nói cách sửa, đặt cạnh ô sai. */
export function useLoiCapThem() {
  const { t, locale } = useT();
  return {
    so: (l: LoiSo): string =>
      l === 'trong'
        ? t('tokenAi.loiSoTrong')
        : l === 'bang-khong'
          ? t('tokenAi.loiSoKhong')
          : l === 'qua-lon'
            ? t('hanMucToken.oQuaLon', { so: soVN(TOKEN_TOI_DA, locale) })
            : t('tokenAi.loiSoSai'),
    ngay: (l: LoiNgay, hienTai?: string): string =>
      l === 'trong'
        ? t('tokenAi.loiNgayTrong')
        : l === 'truoc-hom-nay'
          ? t('tokenAi.loiNgayTruocHomNay')
          : l === 'truoc-ngay-bat-dau'
            ? t('tokenAi.loiNgayTruocBatDau')
            : t('tokenAi.loiNgayKhongSau', { ngay: ngayVN(hienTai ?? null) }),
  };
}

/**
 * Câu lỗi chung của một hộp: `null` khi lỗi đã hiện ở một ô (`daCoO`). Lỗi `400` mà con trỏ không thuộc ô nào
 * của hộp (ví dụ `#/status` khi yêu cầu vừa được người khác xử lý, hay đã đủ 3 yêu cầu đang chờ) thì hiện
 * nguyên câu của server, không thay bằng câu chung "sửa trường được đánh dấu" khi chẳng có ô nào được đánh dấu.
 */
export function cauLoiChung(
  err: unknown,
  loiServer: Record<string, string>,
  daCoO: readonly string[],
  dichLoi: (e: unknown) => string,
): string | null {
  if (!err) return null;
  if (daCoO.some((k) => loiServer[k])) return null;
  const khac = Object.entries(loiServer)
    .filter(([k]) => !daCoO.includes(k))
    .map(([, v]) => v);
  return khac.length > 0 ? khac.join(' ') : dichLoi(err);
}
